import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";

const ConsumptionLineChart = ({
  data,
  selectedRange,
  customRange,
  title,
  lines = [], // 👈 multiple lines [{ key, color, name }]
  prepareLineChartData,
  height,
}) => {
  const CustomTooltip = ({ active, payload, label }) => {
    if (!active || !payload || !payload.length) return null;

    return (
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #ccc",
          borderRadius: "4px",
          padding: "8px",
          zIndex: 9999,
          position: "relative",
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ marginBottom: "4px", fontSize: "11px", color: "#666" }}>
          {label}
        </div>
        {payload.map((entry, index) => (
          <div
            key={`item-${index}`}
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <div
              style={{
                width: "12px",
                height: "12px",
                backgroundColor: entry.color,
                borderRadius: "2px",
              }}
            />
            <span>
              {entry.name}: {entry.value}
            </span>
          </div>
        ))}
      </div>
    );
  };

  const chartData = prepareLineChartData();

  return (
    <ResponsiveContainer width="100%" height={height}>
      <LineChart
        data={chartData}
        margin={{
          top: 10,
          right: 20,
          bottom: 0,
          left: -50,
        }}
      >
        <CartesianGrid horizontal={false} vertical={false} />
        <ReferenceLine y={0} stroke="#ccc" strokeWidth={1} />
        <XAxis dataKey="date" axisLine={false} tickLine={false} tick={false} />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={false}
          domain={[dataMin => Math.max(0, dataMin), "auto"]}
        />
        <Tooltip cursor={false} content={<CustomTooltip />} />

        {/* 👇 Render multiple lines dynamically */}
        {lines.map((line, index) => (
          <Line
            key={index}
            type="monotone"
            dataKey={line.key}
            stroke={line.color}
            strokeWidth={2}
            strokeLinecap="round"
            dot={false}
            activeDot={{ r: 3, strokeWidth: 1, fill: "#fff", stroke: line.color }}
            name={line.name}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default ConsumptionLineChart;
